<div class="container-fluid h-100 d-flex flex-column">
  <!-- VPDW-3111: unified page header — title on left, all actions on
       right in a single flex action-row. -->
  <div class="page-head">
    <h1 class="page-title">{{ title }}</h1>
    <div class="action-row">
      <button class="btn btn-outline" (click)="createBidTutorialVideo()">
        Create bid tutorial
      </button>
      <button class="btn btn-outline" (click)="manageBidTutorialVideo()">
        Manage bid tutorial
      </button>
      @if (usesSpotlightVendors) {
        <button
          class="btn btn-outline"
          (click)="generateSpotlightVendorsKPIReport()"
        >
          Spotlight QSB report
        </button>
      }
      <button class="btn btn-primary" (click)="addQuickSourceBid()">
        Add new QuickSource bid
      </button>
    </div>
  </div>

  <div class="row py-2 flex-grow-1">
    <div class="col">
      <app-proposal-requests-grid
        [ColumnIdToColumnActions]="ColumnIdToColumnActions"
        [gridName]="'ProposalRequests'"
        [(reloadGridData)]="reloadGrid"
        [suppliedQueryData]="suppliedGridQueryData"
        [getCalculatedColumnActions]="getDisplayedColumnActions"
        [FilterModel]="FilterModel"
        [TooltipMap]="TooltipMap"
        (actionEvent)="action($event)"
      ></app-proposal-requests-grid>
    </div>
  </div>

  <div class="row row-padding-bottom">
    <div class="col"></div>
    <div class="col-auto">
      <div class="form-check-group">
        <input
          type="checkbox"
          class="form-check-input"
          [ngModel]="CancelledBidsModel.show"
          (ngModelChange)="deleteBidChange($event)"
        />
        <label class="my-0 ms-1 form-check-label">Show deleted bids</label>
      </div>
    </div>
  </div>
</div>
